import styles from './AccordionItem.module.css';

interface AccordionItemProps {
    question: string;
    answer: string;
    isOpen: boolean;
    onClick: () => void;
}

const AccordionItem = ({ question, answer, isOpen, onClick }: AccordionItemProps) => {
    return (
        <div className={styles.accordionItem}>
            <button className={styles.accordionHeader} onClick={onClick}>
                <span className={styles.accordionTitle}>{question}</span>
                <i
                    className={`ri-arrow-down-s-line ${styles.accordionIcon} ${isOpen ? styles.iconOpen : ''}`}
                    aria-hidden="true"
                ></i>
            </button>
            <div className={`${styles.accordionCollapse} ${isOpen ? styles.collapseOpen : ''}`}>
                <div className={styles.accordionBody}>{answer}</div>
            </div>
        </div>
    );
};

export default AccordionItem;
